import React, { useState } from 'react';
import * as PropTypes from 'prop-types';

import TextInput from '../../TextInput';
import ErrorBlock from '../ErrorBlock';

function AmountInput({
  type,
  name,
  label,
  limit,
  value,
  onChange,
  showError,
  inputMode,
  className,
  placeholder,
  validationRule,
  errorText,
}) {
  const [isError, setError] = useState(showError);

  const handleChange = val => {
    const error = val ? !validationRule(val) : false;
    setError(error);
    onChange(val, error);
  };

  return (
    <div>
      <TextInput
        rounded
        name={name}
        type={type}
        value={value}
        limit={limit}
        label={label}
        inputMode={inputMode}
        placeholder={placeholder}
        className={className}
        onChange={handleChange}
      />
      <If condition={Boolean(isError)}>
        <ErrorBlock errors={errorText} className="mt3" />
      </If>
    </div>
  );
}

AmountInput.propTypes = {
  type: PropTypes.string,
  validationRule: PropTypes.func,
  onChange: PropTypes.func,
  limit: PropTypes.number,
  value: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.string,
  inputMode: PropTypes.string,
  placeholder: PropTypes.string,
  errorText: PropTypes.string,
  className: PropTypes.string,
  showError: PropTypes.bool,
};

export default AmountInput;



// WEBPACK FOOTER //
// ./src/components/common/AmountInput/index.jsx